import React from 'react'
import md5 from 'md5'
import { v4 as uuidv4 } from 'uuid'
import "../css/login-style.css"
import "../css/general-style.css"

// Servicios
import { getValueCookie, setNewCookie, removeCookie } from '../services/cookieService'
import { OpenCompanyDashBoard, OpenLobby, OpenLogin } from '../functions/pagesFunction'
import { selectWithDataService } from '../services/auth/authservices'
import { automaticCloseAlert, confirmCloseAlert } from '../functions/alerts'
import { closeSession } from "../functions/closeSession"
import { executeRedirect } from '../functions/redirectHelper';

// Componentes
import App from '../components/App'
import LoadingWindow from '../components/LoadingWindow'

export default class Login extends React.PureComponent {
  constructor(props) {
    super(props)
    this.ModalLoading = React.createRef()
    this.state = {
      loginData: {
        userName: '',
        password: ''
      },
      showPassword: false,
      rememberMe: false
    }
  }

  componentDidMount() {
    // Redirigir si ya hay sesión
    const user = getValueCookie('userName');
    const company = getValueCookie('Company');

    if (user) {
      const redirectTo = getValueCookie('redirectTo')

      if (redirectTo && company) {
        // Clear redirect secion
        removeCookie('redirectTo');
        // Make redirect
        executeRedirect(redirectTo);
      } else {
        company ? OpenLobby() : OpenCompanyDashBoard()
      }
    } else {
      // Mostrar username en caso de tener remember me activado
      const usernameInput = getValueCookie('usernameInput')
      const rememberMe = getValueCookie('rememberMe')
      if (rememberMe && usernameInput) {
        this.setState(prev => ({ loginData: {...prev.loginData, userName: usernameInput} }))
      }
      // Mostrar login
      OpenLogin()
    }
  }

  // Manejador de inputs
  handleChange = (e, field) => {
    this.setState(prev => ({
      loginData: {
        ...prev.loginData,
        [field]: e.target.value
      }
    }))
  }

  // Activar login con ENTER
  handleKeyDown = async e => {
    if (e.key === 'Enter') {
      await this.handleLogin()
    }
  }

  // Mostrar / ocultar contraseña
  togglePasswordVisibility = () => {
    this.setState(prev => ({ showPassword: !prev.showPassword }))
  }

  // Activar / desactivar remember me
  handleRememberMeChange = (e) => {
    this.setState({ rememberMe: e.target.checked });
  }

  // Login principal
  async handleLogin() {
    const { userName, password } = this.state.loginData
    const btn = document.getElementById('btn_signin')
    const originalLabel = btn.innerHTML

    // Preparar UI
    btn.disabled = true
    btn.innerHTML = 'Loading ...'
    // this.ModalLoading.current.showState(true)

    const response = await selectWithDataService({
      userName,
      password: md5(password)
    }, "/login")

    if (response && response.status && response.status.code === 1) {
      if (response.token !== 'invalid') {
        // Guardar sesión
        automaticCloseAlert('correct', `Welcome: ${response.data.name} ${response.data.surname}`)
        // Expiraton time en horas
        const expirationHours = this.state.rememberMe ? 120 : 24
        // Guardar cookies
        setNewCookie('sessionAuthToken', response.token, expirationHours)
        setNewCookie('userName', response.data.userName, expirationHours)
        setNewCookie('usernameInput', response.data.userName, expirationHours)
        setNewCookie('rememberMe', this.state.rememberMe ? true : false, expirationHours)
        setNewCookie('name', response.data.name, expirationHours)
        setNewCookie('surname', response.data.surname, expirationHours)
        // Redireccionar
        localStorage.setItem('session', uuidv4())
        window.location.reload()
        return
      } else {
        closeSession()
        confirmCloseAlert('incorrect', 'Your Username or Password are incorrect. Please try again')
        this.setState(prev => ({
          loginData: { ...prev.loginData, password: '' }
        }))
      }
    }

    // Restaurar UI
    this.ModalLoading.current.showState(false)
    btn.innerHTML = originalLabel
    btn.disabled = false
  }

  render() {
    const { loginData, showPassword } = this.state;
    const user = getValueCookie('userName');

    return (
      <React.Fragment>
        <LoadingWindow ref={this.ModalLoading} />

        <div className="auth-page-wrapper pt-5 page" id='login'>
          <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
            <div className="bg-overlay" />
            <div className="shape">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1440 120">
                <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z" fill="#fff" />
              </svg>
            </div>
            <canvas className="particles-js-canvas-el" width="2880" height="760" style={{ width: '100%', height: '100%' }} />
          </div>

          <div className="auth-page-content">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="text-center mt-sm-5 mb-4 text-white-50">
                    <div>
                      <div className="d-inline-block auth-logo">
                        <img src="/images/logo_mayaland.png" alt="" height="50" />
                      </div>
                    </div>
                    
                    <hr />

                    <p className="mt-3 fs-15 fw-medium">Portal Manager</p>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6 col-xl-5">
                  <div className="card mt-4">
                    <div className="card-body p-4">
                      <div className="text-center mt-2">
                        <h5 className="text-primary">LOGIN</h5>
                      </div>

                      <div className="p-2 mt-4">
                        {/* Username */}
                        <div className="mb-3">
                          <label htmlFor="username" className="form-label">Username</label>
                          <input
                            type="text"
                            id="username"
                            name="username"
                            className="form-control"
                            placeholder="Enter username"
                            value={loginData.userName}
                            onChange={(e) => this.handleChange(e, 'userName')}
                            onKeyDown={this.handleKeyDown}
                          />
                        </div>

                        {/* Password */}
                        <div className="mb-3">
                          <div className="float-end">
                            <a href="/recovery" className="text-muted">Forgot password?</a>
                          </div>
                          <label htmlFor="password-input" className="form-label">Password</label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <input
                              type={showPassword ? 'text' : 'password'}
                              id="password-input"
                              name="password"
                              className="form-control pe-5 password-input"
                              placeholder="Enter password"
                              autoComplete="off"
                              value={loginData.password}
                              onChange={(e) => this.handleChange(e, 'password')}
                              onKeyDown={this.handleKeyDown}
                            />
                            <button
                              type="button"
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                              onClick={this.togglePasswordVisibility}
                            >
                              <i className={showPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'}></i>
                            </button>
                          </div>
                        </div>

                        {/* Remember me */}
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="auth-remember-check"
                            checked={this.state.rememberMe}
                            onChange={this.handleRememberMeChange}
                          />
                          <label className="form-check-label" htmlFor="auth-remember-check">
                            Remember me
                          </label>
                        </div>

                        {/* Submit */}
                        <div className="mt-4">
                          <button type="button" className="btn darkPurpleBackground w-100" id="btn_signin" onClick={() => this.handleLogin()}>
                            Sign In
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {user && (
          <div id='App' className='page'>
            <App />
          </div>
        )}
      </React.Fragment>
    )
  }
}